import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const LINKS = [{
  label: 'Nosotros',
  href: '#quienes-somos'
}, {
  label: 'Sectores',
  href: '#sectores'
}, {
  label: 'Servicios',
  href: '#servicios'
}, {
  label: 'Clientes',
  href: '#clientes'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b transition-all duration-300 ${scrolled ? 'border-white/15 bg-vm-bg/95 backdrop-blur-md' : 'border-transparent bg-vm-bg'}`} data-id="element-126" data-mp="eh1kwadck32g">
      <nav className="mx-auto flex h-24 max-w-7xl items-center justify-between px-6 lg:px-10" data-id="element-127" data-mp="1kzqargbqb9oa">
        <a href="#top" aria-label="Vivo Media — Inicio" className="flex h-20 w-[260px] shrink-0 items-center sm:h-24 sm:w-[340px]" data-id="element-128" data-mp="9ohhxf8t37oc">
          <img src="https://cdn.magicpatterns.com/uploads/mzH2PN3mqF9aVPxsFuUwSS/logo_png_blanco.png" alt="Vivo Media — Tecnología visual en movimiento" className="h-full w-full origin-left scale-[2] object-contain object-left" data-id="element-129" data-mp="epnexp9i1h3o" />
        </a>

        <ul className="hidden items-center gap-8 md:flex" data-id="element-130" data-mp="3n574oeayohdz">
          {LINKS.map(link => <li key={link.href} data-id="element-131" data-mp="3s2yt2ycedldf">
              <a href={link.href} className="text-sm font-medium uppercase tracking-[0.08em] text-white transition-colors hover:text-vm-muted" data-id="element-132" data-mp="w5w66on08ep">
                {link.label}
              </a>
            </li>)}
        </ul>

        <a href="#contacto" className="hidden items-center rounded-[4px] border-2 border-vm-electric px-5 py-2 text-sm font-semibold uppercase tracking-[0.1em] text-white transition-colors hover:bg-vm-electric md:inline-flex" data-id="element-133" data-mp="34do1a6d0z1bf">
          Contactar
        </a>

        <button type="button" onClick={() => setOpen(v => !v)} className="p-2 text-white md:hidden" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} data-id="element-134" data-mp="2wcq84fzpfo9m">
          {open ? <XIcon className="h-6 w-6" data-id="element-135" data-mp="362i33bbpujem" /> : <MenuIcon className="h-6 w-6" data-id="element-136" data-mp="364ch05oklb97" />}
        </button>
      </nav>

      {open && <div className="border-t border-white/15 bg-vm-bg md:hidden" data-id="element-137" data-mp="2iei4xqc2rqq0">
          <ul className="space-y-4 px-6 py-6" data-id="element-138" data-mp="2devpda8rxye1">
            {LINKS.map(link => <li key={link.href} data-id="element-139" data-mp="2sbmodiejd834">
                <a href={link.href} onClick={() => setOpen(false)} className="block text-sm font-medium uppercase tracking-[0.1em] text-white transition-colors hover:text-vm-muted" data-id="element-140" data-mp="2s8igob1v3u7p">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>}
    </header>;
}